import React from 'react';
import {
	IonContent,
	IonPage,
	IonRefresher,
	IonRefresherContent,
} from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { axius, func, types } from 'utils';
import { Empty, Header } from 'components';
import { _store, _update } from '_Store';

import './_User.scss';
import FormWallet from './FormWallet';

interface Props extends RouteComponentProps, types.StateProps {}
const Wallet: React.FC<Props> = (props) => {
	const {
		__auth: { user },
	} = _store.useState();

	const [fund, setFund] = React.useState(false);
	const [data, setData] = React.useState<types.Payment[]>([]);
	const [loading, setLoading] = React.useState({ page: true, modal: false });

	let refresher: any = null;

	React.useEffect(() => {
		getData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getData = () => {
		setLoading((sl) => ({ ...sl, page: true }));
		func.scrollToTop();
		setData([]);
		Promise.all([
			axius.get(`users/me`),
			axius.get(`payments`, { cursor: '0-20' }),
		]).then((res) => {
			res[0].status === 200 && _update.auth('user', res[0].data);
			res[1].status === 200 && setData(res[1].data || []);
			setLoading((sl) => ({ ...sl, page: false }));
			refresher && refresher.detail.complete();
		});
	};

	return (
		<IonPage id="Wallet">
			<Header {...props} showSearch={false} />

			<IonContent fullscreen>
				<IonRefresher
					slot="fixed"
					onIonRefresh={(e) => {
						refresher = e;
						getData();
					}}
				>
					<IonRefresherContent></IonRefresherContent>
				</IonRefresher>
				<div
					className="px-4 py-4 title bg-img mx-4 mt-2 mt-4 d-flex align-items-center-"
					style={{
						backgroundImage: `url(assets/img/wallet.jpg)`,
						height: 'auto',
						borderRadius: 8,
						boxShadow: '#917676 2px 3px 8px',
					}}
				>
					<div style={{ width: '100%' }}>
						<div className="d-flex justify-content-between text-white">
							<div className="small">Available Balance</div>
							<div className="small" onClick={() => setFund(true)}>
								<i className="fa fa-plus-circle" /> Fund Wallet
							</div>
						</div>
						<div className="fw-600 mt-2 secondary" style={{ fontSize: 25 }}>
							₦{func.format.number(user.wallet)}
						</div>
						<div
							className="text-uppercase text-center fs-20 mt-3 fw-600 text-white"
							style={{ opacity: 0.4 }}
						>
							{user.name}
						</div>
					</div>
				</div>

				<div className="p-4">
					{loading.page &&
						[...Array(8)].map((_, i) => (
							<div
								key={i}
								className="skeleton mb-2"
								style={{ borderRadius: 7, height: 83 }}
							/>
						))}

					{!loading.page && data.length === 0 && (
						<Empty text="No transactions found." style={{}} />
					)}

					{!loading.page &&
						data.length > 0 &&
						data.map((item, i) => (
							<div
								key={`${i}_${item.id}`}
								className="mb-2 px-3 py-3"
								style={{
									backgroundColor: 'rgba(255, 204, 0, .2)',
									borderRadius: 4,
								}}
							>
								<div>
									{item.order && item.order?.id && (
										<span
											className="fw-500 underline primary"
											onClick={() =>
												props.history.push(`/user/orders/${item.order?.id}`)
											}
										>
											Order #{item.order?.id}{' '}
										</span>
									)}
									{item.description}
								</div>
								<div className="d-flex justify-content-between align-items-center mt-2">
									<div className="small text-muted">
										{func.format.date(item.createdAt)}
									</div>
									<div
										className={`
                                        ${item.status === types.PaymentStatuses.PENDING && 'text-muted'}                                        
                                        ${item.status === types.PaymentStatuses.COMPLETED && item.operation === types.PaymentOperations.ADD && 'success'} 
                                        ${item.status === types.PaymentStatuses.COMPLETED && item.operation === types.PaymentOperations.SUBTRACT && 'danger'}
                                        fw-500 fs-20-
                                    `}
									>
										₦{func.format.number(item.amount)}
										{item.status === types.PaymentStatuses.FAILED && (
											<div className="small text-sm text-right text-muted">
												failed
											</div>
										)}
									</div>
								</div>
							</div>
						))}
				</div>

				<FormWallet fund={fund} setFund={setFund} history={props.history} />
			</IonContent>
		</IonPage>
	);
};

export default Wallet;
